import Vue from 'vue'

import { findAll, payCharge, generateReport } from '@/views/charge/chargeService'

import { generateExcelLink } from '@/util/helpers'

const message = 'charge.messages'

const state = {
  charges: [],
  isBeingPaid: false,
}

const getters = {
  charges: (state) => state.charges,
  isBeingPaid: (state) => state.isBeingPaid,
}

const actions = {
  async fetchCharges({ commit, dispatch, rootState }) {
    commit('setIsLoading', true)

    const defaultParams = {
      size: rootState.paginate.itemsPerPage,
      page: rootState.paginate.currentPage - 1,
    }

    const params = { ...defaultParams, ...rootState.filters.filters }

    try {
      const { data } = await findAll(params)
      const { result, total } = await data

      commit('setCharges', result)
      commit('setTotalPages', total)
    } catch ({ data }) {
      dispatch('showErrorMessage', data.message)
    } finally {
      commit('setIsLoading', false)
    }
  },

  async doPayment({ commit, dispatch }, charges) {
    commit('setIsBeingPaid', true)

    const paymentData = {
      installment_amount: 1,
      charge_ids: charges,
      method: 'BALANCE',
    }

    try {
      await payCharge(paymentData)
      commit('closeAllModals')
      dispatch('fetchCharges')
      dispatch('fetchCurrentRealEstate')
      dispatch(
        'showSuccessMessage',
        Vue.i18n.translate(`${message}.successfullyPaid`)
      )
    } catch ({ data }) {
      data?.errors && data?.errors?.length >= 1
        ? dispatch('showErrorMessage', data.errors[0].message)
        : dispatch('showErrorMessage', data.message)
    } finally {
      commit('setIsBeingPaid', false)
    }
  },

  async fetchChargeReport({ commit, dispatch, rootState }) {
    commit('setIsGeneratingReport', true)

    const params = rootState.filters.filters

    try {
      const response = await generateReport(params)
      generateExcelLink(response, Vue.i18n.translate('charge.label.chargeReport'))
    } catch ({ data }) {
      dispatch('showErrorMessage', data.message)
    } finally {
      commit('setIsGeneratingReport', false)
    }
  },
}

const mutations = {
  setCharges: (state, charges) => {
    state.charges = charges
  },

  setIsBeingPaid: (state, status) => {
    state.isBeingPaid = status
  },
}

export default {
  state,
  mutations,
  actions,
  getters,
}
